<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalClass]="modalClass"
    [modalHelpIndex]="modalHelpIndex" [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()"
    (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage">

    <div class="left-section">
        <div class="search-task-container" data-automation-id="create-data-set-from-search-results-search-task-label">
            <span> Search task:</span>
            <div class="query-string">
                <div class="query-container colorized-container" id="queryOutputPanel">
                    <span [innerHTML]="queryStr" data-automation-id="advanced-search-query-input"></span>
                </div>
            </div>
        </div>
        <div class="document-count-container">
            <span> Documents:</span>
            <span class="doc-count"
                data-automation-id="create-data-set-from-search-results-documents-label">{{documentCounts}}</span>
        </div>
    </div>
    <div class="right-section">
        <res-new-data-set-load-file-menu [modalAutomationId]="modalAutomationId"></res-new-data-set-load-file-menu>
        @if (hasAddToProjectPermissions) {
            <div class="right-footer modal-row path-area" [hidden]="isLoadFile">
                <div class="modal-row-column-auto">
                    <res-custom-checkbox [automationId]="modalAutomationId + '-add-to-project-data'" [(ngModel)]="addToProjectData"
                        content="Add to Project Data"
                        [isDisabled]="menuComponent.getIndexLevelSetting().indexLevelType === IndexLevel.DO_NOT_INDEX || menuComponent.getIndexLevelSetting().indexLevelType === IndexLevel.SYSTEM_METADATA || menuComponent.getIndexLevelSetting().indexLevelType === IndexLevel.FILE_METADATA">
                    </res-custom-checkbox>
                </div>
            </div>
        }
    </div>
</res-base-modal>